<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Tipos de Vehículo</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item"></li>
                  <li class="breadcrumb-item">Administración</li>
                  <li class="breadcrumb-item">Flota</li>
                  <li class="breadcrumb-item active">Tipos de Camión</li>
                  <li class="breadcrumb-item active">
                    Formulario {{ accion }}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="col-6 pt-2 pb-2">
                <h5 class="mb-0">Formulario {{ accion }} Tipos de Vehículo</h5>
              </div>
              <!-- Pestañas eliminadas - solo se muestra el formulario principal -->
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade active show" id="Principal">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="nombre">Nombre Tipo de Camión</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            id="nombre"
                            v-model="form.nombre"
                            :class="
                              $v.form.nombre.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                            @input="validaNombre"
                          />
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <label for="cantidad_pasajeros"
                            >Cantidad de pasajeros</label
                          >
                          <input
                            type="number"
                            class="form-control form-control-sm"
                            id="cantidad_pasajeros"
                            v-model="form.cantidad_pasajeros"
                            :class="
                              $v.form.cantidad_pasajeros.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group col-md-3">
                        <label for="sitio">Clasificación</label>
                        <select
                          class="form-control form-control-sm"
                          v-model="form.tipo"
                          :class="
                            $v.form.tipo.$invalid ? 'is-invalid' : 'is-valid'
                          "
                        >
                          <option value="">Seleccione...</option>
                          <option
                            v-for="tipo_vehi in objLista.tipo_vehiculo"
                            :key="tipo_vehi.numeracion"
                            :value="tipo_vehi.numeracion"
                          >
                            {{ tipo_vehi.descripcion }}
                          </option>
                        </select>
                        <div class="error" v-if="!$v.form.tipo.required">
                          Seleccione un tipo de camión
                        </div>
                      </div>
                      <div class="form-group col-md-3" v-if="form.tipo > 0">
                        <label for="confirmacionVehi"
                          >¿Requiere
                          {{ form.tipo == 1 ? "Trailer" : "Cabezote" }}?</label
                        >
                        <div class="input-group">
                          <div class="custom-control custom-radio m-1">
                            <input
                              class="m-1"
                              type="radio"
                              name="confirmacionVehi"
                              id="confirmacionVehi_si"
                              value="1"
                              v-model="form.check_tipo"
                              @change="validarCheck(1)"
                            />
                            <label
                              class="form-check-label"
                              for="confirmacionVehi_si"
                            >
                              Si
                            </label>
                          </div>
                          <div class="custom-control custom-radio m-1">
                            <input
                              class="m-1"
                              type="radio"
                              name="confirmacionVehi"
                              id="confirmacionVehi_no"
                              value="0"
                              v-model="form.check_tipo"
                              @change="validarCheck(1)"
                              :class="
                                $v.check.$invalid ? 'is-invalid' : 'is-valid'
                              "
                            />
                            <label
                              class="form-check-label"
                              for="confirmacionVehi_no"
                            >
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Líneas de negocio ocultas - se asigna automáticamente línea 15 al crear -->
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <button
                    class="btn bg-primary col-md-1"
                    v-show="!$v.form.$invalid"
                    @click="save()"
                  >
                    <i class="fas fa-paper-plane"></i><br />Guardar
                  </button>
                  <button class="btn bg-secondary col-md-1" @click="back()">
                    <i class="fas fa-reply"></i><br />Volver
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import loading from "../../../../components/Loading";

export default {
  name: "TipoVehiculoForm",
  components: {
    loading,
  },
  data() {
    return {
      cargando: false,
      form: {},
      accion: "",
      metodo: "",
      objLista: {
        tipo_vehiculo: [],
      },
      modal: {
        title: "",
        accion: "",
      },
      id: this.$route.params.id,
    };
  },
  validations: {
    check: {
      required,
    },
    form: {
      nombre: {
        required,
      },
      cantidad_pasajeros: {
        required,
      },
      tipo: {
        required,
      },
    },
  },
  methods: {
    validarCheck(act) {
      if (act == 1) {
        if (this.form.tipo == 1) {
          if (this.form.check_tipo == 1) {
            this.form.check_tipo = 2;
          } else {
            this.form.check_tipo = 0;
          }
        } else if (this.form.tipo == 2) {
          if (this.form.check_tipo == 1) {
            this.form.check_tipo = 1;
          } else {
            this.form.check_tipo = 0;
          }
        } else if (this.form.tipo == 0) {
          this.form.check_tipo = 0;
        }
      } else {
        if (this.form.check_tipo == 1 || this.form.check_tipo == 2) {
          this.form.check_tipo = 1;
        }
      }
    },

    getClasificadorTiposVehiculos() {
      axios.get("/api/lista/185").then((response) => {
        this.objLista.tipo_vehiculo = response.data;
      });
    },

    validaNombre() {
      if (this.form.nombre) {
        let id = [];
        if (this.form.id) {
          id.push(this.form.id);
        }
        let filtro = {
          not_id: id,
          nombre_igual: this.form.nombre,
        };
        axios
          .get("/api/admin/tiposVehiculos/lista", {
            params: filtro,
          })
          .then((response) => {
            if (response.data.length > 0) {
              this.$swal({
                icon: "error",
                title: "El Tipo de vehículo digitado ya está creado...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
              this.form.nombre = null;
            }
          });
      }
    },

    save() {
      this.cargando = true;
      if (!this.$v.form.$invalid) {
        // Al crear un tipo de vehículo, asignar automáticamente línea de negocio 15
        if (this.metodo === "POST") {
          this.form.lineas_negocio_id = [15];
        }

        axios({
          method: this.metodo,
          url: "/api/admin/tiposVehiculos",
          data: this.form,
        })
          .then((response) => {
            this.$swal({
              icon: "success",
              title: "Se actualizo el tipo de vehículo...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.cargando = false;
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.cargando = false;
          });
      }
    },

    back() {
      return this.$router.replace("/Argentina/Flota/TiposVehiculo");
    },

    init() {
      this.cargando = true;
      this.accion = this.$route.params.accion;
      if (this.$route.params.accion == "Editar") {
        this.form = this.$route.params.data_edit;
        this.validarCheck(0);
        this.metodo = "PUT";
      } else {
        this.metodo = "POST";
      }
      this.cargando = false;
    },
  },
  mounted() {
    this.init();
    this.getClasificadorTiposVehiculos();
  },
};
</script>
